export const initialPagination = {
  currentPage: 1,
  pageCount: 1,
  perPage: 10,
  totalCount: 0,
}
